import { testimonials } from "@/mocks/news";

export default function TestimonialSection() {
  return (
    <section aria-label="读者口碑" className="w-full bg-secondary-100/70 border-y border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-2xl mb-8">
          <p className="text-xs font-label text-secondary-700 tracking-widest mb-2">VOICES</p>
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
            吃瓜前线的人怎么说
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg bg-background-50 border border-secondary-200 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true"></i>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 font-heading text-sm font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="text-sm font-label font-medium text-foreground-900">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}